export enum LeaveRequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
}

export interface LeaveType {
  id: number;
  name: string;
  description?: string | null;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface LeaveRequestDay {
  id: number;
  date: string;
}

export interface LeaveRequestUser {
  id: number;
  username?: string;
  email?: string;
  nickName?: string;
  department?: string | null;
  profile?: { avatar?: string };
}

export interface LeaveRequestApprover {
  id: number;
  username?: string;
  email?: string;
  nickName?: string;
}

export interface LeaveRequest {
  id: number;
  status: LeaveRequestStatus;
  reason: string;
  reviewNote?: string | null;
  user?: LeaveRequestUser;
  leaveType?: Pick<LeaveType, 'id' | 'name'>;
  assignedApprover?: LeaveRequestApprover | null;
  approvedBy?: LeaveRequestApprover | null;
  approvedAt?: string | null;
  days: LeaveRequestDay[];
  createdAt: string;
  updatedAt: string;
}

export interface LeaveRequestFilter {
  page: number;
  limit: number;
  status?: LeaveRequestStatus;
  from?: string;
  to?: string;
  userId?: number;
  assignedApproverId?: number;
}

export interface LeaveRequestListResponse {
  data: LeaveRequest[];
  metadata: {
    total: number;
    totalPage: number;
    limit: number;
    page: number;
  };
}
